<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M15.0276 10.0956L13.8181 11.2781L13.8108 11.286C13.6235 11.4901 13.34 11.6004 13.0685 11.6004C12.7814 11.6004 12.5101 11.4953 12.2868 11.2949C11.8731 10.854 11.8844 10.1726 12.2897 9.76784L13.4927 8.56713C14.6367 7.42431 14.6369 5.59234 13.4928 4.4497C12.9501 3.90758 12.2071 3.59281 11.4324 3.59281C10.6577 3.59281 9.9148 3.90753 9.37204 4.44958L8.21051 5.60878C7.77007 6.02744 7.08464 6.0192 6.67671 5.61508C6.2571 5.17439 6.26649 4.48862 6.67358 4.0819L7.83831 2.91951C9.82885 0.931417 13.0568 0.953312 15.0253 2.91858C16.9941 4.90874 16.992 8.13201 15.0276 10.0956Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.97085 15.2072C8.98673 16.19 7.68225 16.6932 6.37688 16.6932C5.07188 16.6932 3.76759 16.1902 2.78378 15.2079C0.814449 13.2173 0.817004 9.99292 2.7828 8.02941L3.87663 6.93753L0.46967 3.53057C0.176777 3.23768 0.176777 2.76281 0.46967 2.46991C0.762563 2.17702 1.23744 2.17702 1.53033 2.46991L15.5303 16.4699C15.8232 16.7628 15.8232 17.2377 15.5303 17.5306C15.2374 17.8235 14.7626 17.8235 14.4697 17.5306L11.0596 14.1205L9.97085 15.2072ZM9.52767 12.5886L8.43733 13.677C7.29358 14.8193 5.46031 14.8193 4.31638 13.677C3.17236 12.5343 3.17252 10.7024 4.31646 9.55954L5.40853 8.46943L6.70523 9.76613L6.64086 9.82419C6.23364 10.2309 6.22422 10.9168 6.64392 11.3575C6.85278 11.5647 7.11414 11.6569 7.41982 11.6569C7.69136 11.6569 7.97483 11.5467 8.1622 11.3426L8.22189 11.2828L9.52767 12.5886Z"
    />
    <path
      d="M11.3564 6.63995C11.7759 7.08053 11.7667 7.76605 11.3599 8.17281L10.525 9.00024L9 7.4679L9.8227 6.64619C10.2631 6.22758 10.9485 6.23584 11.3564 6.63995Z"
    />
  </svg>
</template>
